"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react2 = require("@prismicio/react");

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _iconCaret = _interopRequireDefault(require("../../../shared/icons/icon-caret.svg"));

var _iconDollar = _interopRequireDefault(require("../../../shared/icons/icon-dollar.svg"));

var _iconArrowBullet = _interopRequireDefault(require("../../../shared/icons/icon-arrow-bullet.svg"));

var _isEnterOrSpace = _interopRequireDefault(require("../../../shared/helpers/isEnterOrSpace"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var iconMap = {
  Money: _iconDollar["default"]
};

var DetailsExpandableCard = function DetailsExpandableCard(_ref) {
  var _ref$sliceData = _ref.sliceData,
      items = _ref$sliceData.items,
      _ref$sliceData$primar = _ref$sliceData.primary,
      body = _ref$sliceData$primar.details_card_body,
      image = _ref$sliceData$primar.details_card_image,
      incentive = _ref$sliceData$primar.details_card_incentive_copy,
      icon = _ref$sliceData$primar.details_card_incentive_icon,
      title = _ref$sliceData$primar.details_card_title;
  var Icon = icon && iconMap[icon] || null;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var expandIconClass = (0, _classnames["default"])({
    'content-page__expandable-details-caret': true,
    'content-page__expandable-details-caret--open': open
  });
  var detailsContainerClassNames = (0, _classnames["default"])('content-page__expandable-details-items', {
    'content-page__expandable-details-items--hidden': !open
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-image"
  }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicImage, {
    field: image,
    widths: [640]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-description"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__rich-text",
    content: title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-body-wrapper"
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "content-page__expandable-details-incentive-icon"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-body"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__expandable-details",
    content: incentive
  }), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__rich-text",
    content: body
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-trigger content-page__expandable-details-trigger--mobile",
    "aria-expanded": open,
    onClick: function onClick() {
      return setOpen(!open);
    },
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && setOpen(!open);
    },
    role: "button",
    tabIndex: 0
  }, "View details", /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
    className: expandIconClass
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: detailsContainerClassNames,
    "aria-live": "polite",
    "aria-hidden": !open
  }, items.map(function (_ref2, idx) {
    var heading = _ref2.details_card_detail_heading,
        content = _ref2.details_card_detail_content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__expandable-details-item",
      key: "expanded-details-".concat(idx)
    }, heading.length > 0 && /*#__PURE__*/_react["default"].createElement(_iconArrowBullet["default"], {
      className: "content-page__expandable-details-item-icon"
    }), /*#__PURE__*/_react["default"].createElement("div", null, heading.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__expandable-details-item-heading"
    }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      baseClass: "content-page__rich-text",
      content: heading
    })), content.length > 0 && /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      baseClass: "content-page__rich-text",
      content: content
    })));
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__expandable-details-trigger content-page__expandable-details-trigger--desktop",
    "aria-expanded": open,
    onClick: function onClick() {
      return setOpen(!open);
    },
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && setOpen(!open);
    },
    role: "button",
    tabIndex: 0
  }, "View details", /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
    className: expandIconClass
  }))));
};

DetailsExpandableCard.propTypes = {
  sliceData: _propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      details_card_detail_heading: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      details_card_detail_content: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    })).isRequired,
    primary: _propTypes["default"].shape({
      details_card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      details_card_image: _propTypes["default"].shape({}),
      details_card_incentive_copy: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      details_card_incentive_icon: _propTypes["default"].string,
      details_card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    }).isRequired
  }).isRequired
};
var _default = DetailsExpandableCard;
exports["default"] = _default;